<template>
  <div class="page-wrapper">
    <div class="tabbar">
      <router-link class="tabbar-item" v-for="(item, index) in tabs" :to="item.path" :key="index">
        <div class="tabbar-icon"><img :src="item.icon"></div>
      </router-link>
      <div class="tabbar-indicator" :style="{width: indicatorWidth + 'px', transform: indicatorStyle}"></div>
    </div>
    <keep-alive>
      <router-view class="page-content"></router-view>
    </keep-alive>
  </div>
</template>

<script>
  const tabs = [{
    title: '',
    path: 'borrow',
    icon: require('static/images/icons/tabbar-icon-borrow.png'),
    cls: 'borrow navbar-bg'
  }, {
    title: '发现',
    path: 'discover',
    icon: require('static/images/icons/tabbar-icon-discover.png'),
    cls: 'discover'
  }, {
    title: '我的',
    path: 'user',
    icon: require('static/images/icons/tabbar-icon-user.png'),
    cls: 'user'
  }]

  export default {
    data () {
      return {
        tabs,
        indicatorWidth: 46,
        indicatorStyle: ''
      }
    },
    beforeRouteEnter (to, from, next) {
      if (to.path === '/') {
        next('/borrow')
      } else {
        next()
      }
    },
    created () {
      this.changeTab(this.$route)
      let ev = 'onorientationchange' in window ? 'orientationchange' : 'resize'
      window.addEventListener(ev, () => {
        this.changeTab(this.$route)
      }, false)
    },
    watch: {
      '$route': 'changeTab'
    },
    methods: {
      changeTab (to) {
        let width = document.body.clientWidth
        let itemWidth = width / this.tabs.length
        let index = ['/borrow', '/discover', '/user'].indexOf(to.path)
        let offsetLeft = (itemWidth - this.indicatorWidth) / 2 + itemWidth * index
        this.indicatorStyle = `translateX(${offsetLeft}px)`
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import './common/css/mixmin'

  .tabbar
    display table
    setTopLine(#e2edff)
    position absolute
    bottom 0
    width 100%
    z-index 100
    background-color #fff
    box-shadow 0 -3px 20px rgba(105, 129, 165, .45)

    & ~ .page-content
      bottom 50px

    .tabbar-item
      display table-cell
      padding 6px 0
      text-align center
      text-decoration none

      & + .tabbar-item
        setLeftLine(#e2edff)

      .tabbar-icon
        width 24px
        margin 0 auto

        & > img
          display block
          width 100%
          height 100%

        & + .tabbar-label
          margin-top 5px

      .tabbar-label
        margin 0
        font-size px2rem(12px)
        color #40a3fe

    .tabbar-indicator
      position absolute
      left 0
      bottom 0
      width 46px
      height 3px
      background-color #3a7eeb
      transition transform .2s cubic-bezier(0.215, 0.610, 0.355, 1.000);
</style>



// WEBPACK FOOTER //
// App.vue?3ec0f00d